import { useCallback, useEffect, useRef, useState } from 'react';
import { THROTTLE_MS } from '../constants/THROTTLING';
export const useMediaQuery = (breakpoints, defaultSize) => {
  const setTimeoutRef = useRef(undefined);
  const mediaQueryList = Object.values(breakpoints).map(query => window.matchMedia(query));
  const getCurrentScreen = useCallback(() => {
    const matches = mediaQueryList.filter(mql => mql.matches);
    const matchedScreenSize = matches && matches[0] ? matches[0].media : undefined;
    return matchedScreenSize !== undefined ? Object.keys(breakpoints).find(key => breakpoints[key] === matchedScreenSize) : defaultSize;
  }, [mediaQueryList, breakpoints, defaultSize]);
  const [match, setMatch] = useState(getCurrentScreen());
  useEffect(() => {
    if (mediaQueryList && mediaQueryList.length) {
      const update = () => setMatch(getCurrentScreen());
      const throttleMediaQuery = () => {
        if (setTimeoutRef.current !== undefined) {
          clearTimeout(setTimeoutRef.current);
        }
        setTimeoutRef.current = setTimeout(() => {
          update();
        }, THROTTLE_MS);
        return () => clearTimeout(setTimeoutRef.current);
      };
      mediaQueryList.forEach(mql => {
        var _mql$addEventListener;
        return mql === null || mql === void 0 || (_mql$addEventListener = mql.addEventListener) === null || _mql$addEventListener === void 0 ? void 0 : _mql$addEventListener.call(mql, 'change', () => {
          throttleMediaQuery();
        });
      });
      return () => mediaQueryList.forEach(mql => {
        var _mql$removeEventListe;
        return mql === null || mql === void 0 || (_mql$removeEventListe = mql.removeEventListener) === null || _mql$removeEventListe === void 0 ? void 0 : _mql$removeEventListe.call(mql, 'change', () => {
          throttleMediaQuery();
        });
      });
    }
  }, [getCurrentScreen, mediaQueryList]);
  return match || defaultSize;
};